import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { URLs } from '@core/conf/urls';

@Injectable({
  providedIn: 'root'
})
export class SharedWorksheetImportService {

  constructor(private readonly httpClient: HttpClient) { }

  upload(file): Observable<any> {

    const formData: FormData = new FormData();
    formData.append('file', file);

    const headerOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'multipart/form-data' })
    };
    return this.httpClient.post(URLs.WORKSHEET_IMPORT_ENDPOINT, formData, headerOptions);
  }

  import(): Observable<any> {
    return of(undefined);
  }
}